// extracted by mini-css-extract-plugin
export var readonly = "_i6-1";
export var star = "_i6-0";